// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
    apiKey: "AIzaSyAucvhv8mL9NWvXphzUt6LAhZqKJVwCzXQ",
    authDomain: "yubaba-7bad4.firebaseapp.com",
    databaseURL: "https://yubaba-7bad4.firebaseio.com",
    projectId: "yubaba-7bad4",
    storageBucket: "yubaba-7bad4.appspot.com",
    messagingSenderId: "319156521308",
    appId: "1:319156521308:web:b810baba248e23ed815999",
    measurementId: "G-Z50V882841"
  };
  export const vapiKey = 'BFakXIxsuAMKabnZCqgfdUT5jed6uGIUzNgQH4MGEqKulEIBGWF1bgKKNB_xuVkvyi7xG7UzJ2F9dm2XRCTEkso'